import ApiClient from '@/api/ApiClient';

import type {
  FilterCriteria,
  PagedResultUserContractListItem,
  SortCriteria,
  UserCountStatistics,
} from '../models';

export type SearchContractsRequest = {
  employee?: string;
  employeeDepartmentIds?: string[];
  filterCriteria?: FilterCriteria[];
  includeLimit?: boolean;
  limit?: number;
  skip?: number;
  sortCriteria?: SortCriteria[];
};

export type ContractsStatisticsRequest = {
  employee?: string;
  employeeDepartmentIds?: string[];
  filterCriteria?: FilterCriteria[];
  groupBy?: string;
  includeLimit?: boolean;
  limit?: number;
  skip?: number;
  sortCriteria?: SortCriteria[];
};

export class HrWorkListClient {
  apiClient: ApiClient;

  constructor(apiClient?: ApiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  searchContracts(request: SearchContractsRequest = {}): Promise<PagedResultUserContractListItem> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/hr/works',
      params,
    });
  }

  contractsStatistics(request: ContractsStatisticsRequest = {}): Promise<UserCountStatistics[]> {
    const { ...params } = request;
    return this.apiClient.get({
      path: '/api/hr/works/statistics',
      params,
    });
  }
}

export default HrWorkListClient;
